import { SortSpec, effectiveSort, nextSort, parseSort } from '../components/molecules/dashboard/sortableHeader'

type HeaderProps<TField extends string> = {
  activeField: TField
  activeAsc: boolean
  onSort: (col: TField) => void
}

const useReviewsTableSort = <TField extends string>(
  sort: SortSpec<TField> | undefined,
  defaultSort: SortSpec<TField>,
  onSortChange: (sort: SortSpec<TField> | undefined) => void
): HeaderProps<TField> => {
  const { field: activeField, asc: activeAsc } = parseSort<TField>(effectiveSort(sort, defaultSort))
  const onSort = (col: TField) => onSortChange(nextSort<TField>(col, sort))
  return { activeField, activeAsc, onSort }
}

export default useReviewsTableSort
